import * as React from "react";

const Visa: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 20"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <g fill="none" fillRule="evenodd">
                <rect width="31.5" height="19.5" x=".25" y=".25" fill="#FFF" stroke="#CCC" strokeWidth=".5" rx="2" />
                <path
                    fill="#172B85"
                    d="M24.303 8.985l.528 2.558h-1.48l.952-2.558zM27 13.945l-1.428-6.788H24.04a.795.795 0 00-.741.522l-2.644 6.266h1.851l.37-.991h2.274l.212.991H27zm-8.78-4.908c.054-.365.371-.574.742-.574a3.36 3.36 0 011.745.313l.317-1.462A4.563 4.563 0 0019.385 7c-1.745 0-3.015.94-3.015 2.246 0 .992.9 1.514 1.534 1.828.687.313.952.522.899.835 0 .47-.53.679-1.057.679-.635 0-1.27-.157-1.851-.418l-.318 1.462c.635.261 1.322.366 1.957.366 1.957.052 3.173-.888 3.173-2.298 0-1.776-2.486-1.88-2.486-2.663zm-3.806 4.908h-1.798l1.48-6.788h1.799l-1.481 6.788zm-3.914 0H8.596l-1.428-5.43c-.067-.25-.211-.47-.423-.575A6.211 6.211 0 005 7.366v-.21h3.067c.423 0 .74.315.794.68l.74 3.917 1.904-4.596h1.85L10.5 13.945z"
                />
            </g>
        </svg>
    );
};

export default React.memo(Visa);
